<template>
    <v-row no-gutters class="justify-space-between" v-if="languageData.financialSummary && financialData">
        <v-col md=4 cols=12 class="mb-3">
            <v-card color="white" class="ma-1" style="text-align: left; height: 100%; padding-bottom: 10px; border: 1px solid #252B42 !important">
                <v-card-title class="pa-5 pb-3" color="fontDefault">
                <p class="income-title">{{ languageData.financialSummary.invoiceValueSum }}</p>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                <v-row no-gutters>
                    <v-col cols="12" class="my-auto">
                    <span class="income-value" style="font-size: 38px">{{ financialData.invoicesValueSum + '€' }}</span>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md=4 cols=12 class="mb-3">
            <v-card color="primary" class="ma-1" style="text-align: left; height: 100%; padding-bottom: 10px">
                <v-card-title class="pa-5 pb-3" color="white">
                <p class="income-title" style="color: white !important">{{ languageData.financialSummary.invoicePaymentsSum }}</p>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                <v-row no-gutters>
                    <v-col cols="12" class="my-auto">
                    <span class="income-value" style="font-size: 38px; color: white !important">{{ financialData.invoicesPaymentsSum + '€' }}</span>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md=4 cols=12 class="mb-3">
            <v-card :color="getBalanceCardColor" style="text-align: left; height: 100%; padding-bottom: 10px" class="ma-1">
                <v-card-title class="pa-5 pb-3" color="white">
                <p class="income-title" style="color: white !important">{{ languageData.financialSummary.balance }}</p>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                <v-row no-gutters>
                    <v-col cols="12" class="my-auto">
                    <span class="income-value" style="font-size: 38px; color: white !important">{{ getBalanceValue }}</span>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md=6 cols=12 class="mt-3">
            <v-card color="fontDefault" style="text-align: left; height: 100%; padding-bottom: 10px" class="ma-1">
                <v-card-title class="pa-5 pb-3" color="white">
                <p class="income-title" style="color: white !important">{{ languageData.financialSummary.discountCostSum }}</p>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                <v-row no-gutters>
                    <v-col cols="12" class="my-auto">
                    <span class="income-value" style="font-size: 38px; color: white !important">{{ financialData.invoicesSKontoSum + '€' }}</span>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md=6 cols=12 class="mt-3">
            <v-card color="fontDefault" style="text-align: left; height: 100%; padding-bottom: 10px" class="ma-1">
                <v-card-title class="pa-5 pb-3" color="white">
                <p class="income-title" style="color: white !important">{{ languageData.financialSummary.deductionSum }}</p>
                <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                <v-row no-gutters>
                    <v-col cols="12" class="my-auto">
                    <span class="income-value" style="font-size: 38px; color: white !important">{{ financialData.invoicesDeductionsSum + '€' }}</span>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row> 
</template>

<script>
export default {
  name: "FinancialSummary",
  props: {
    financialData: Object,
  },
  computed: {
    getBalanceCardColor() {
        if (this.financialData.invoicesValueSum > this.financialData.invoicesPaymentsSum) {
            return 'error';
        } else if (this.financialData.invoicesValueSum <= this.financialData.invoicesPaymentsSum) {
            return 'green';
        } else {
            return 'fontDefault';
        }
    },
    getBalanceValue() {
        const balance = (this.financialData.invoicesValueSum - this.financialData.invoicesPaymentsSum).toFixed(2);
        return balance >= 0 ? (balance * -1) + '€' : '+' + (balance * -1) + '€' ;
    },
  },
  mounted() {
  }
}
</script>